// UI STATES
const CHANGE_CURRENT_PAGE = 'fulcrum/container/Admin/User/UserSelection/CHANGE_CURRENT_PAGE'
const CHANGE_PAGE_SIZE = 'fulcrum/container/Admin/User/UserSelection/CHANGE_PAGE_SIZE'
const CHANGE_SEARCH_VALUE = 'fulcrum/container/Admin/User/UserSelection/CHANGE_SEARCH_VALUE'
const UPDATE_SEARCH_VALUE = 'fulcrum/container/Admin/User/UserSelection/UPDATE_SEARCH_VALUE'
const UPDATE_PAGE_SIZE = 'fulcrum/container/Admin/User/UserSelection/UPDATE_PAGE_SIZE'
const UPDATE_COUNT_SIZE = 'fulcrum/container/Admin/User/UserSelection/UPDATE_COUNT_SIZE'
const UPDATE_CURRENT_PAGE = 'fulcrum/container/Admin/User/UserSelection/UPDATE_CURRENT_PAGE'
const USER_SELECTION = 'fulcrum/container/Admin/User/UserSelection'
const UPDATE_USER_LIST = 'fulcrum/container/Admin/User/UserSelection/UPDATE_USER_LIST'
const CLEAR_USER_LIST = 'fulcrum/container/Admin/User/UserSelection/CLEAR_USER_LIST'

const FETCH_USERS = 'fulcrum/container/Admin/User/UserSelection/FETCH_USERS'
const FETCH_USERS_START = 'fulcrum/container/Admin/User/UserSelection/FETCH_USERS_START'
const FETCH_USERS_SUCCESS = 'fulcrum/container/Admin/User/UserSelection/FETCH_USERS_SUCCESS'
const FETCH_USERS_ERROR = 'fulcrum/container/Admin/User/UserSelection/FETCH_USERS_ERROR'

const POST_USER = 'fulcrum/container/Admin/User/UserSelection/POST_USER'
const POST_USER_START = 'fulcrum/container/Admin/User/UserSelection/POST_USER_START'
const POST_USER_SUCCESS = 'fulcrum/container/Admin/User/UserSelection/POST_USER_SUCCESS'
const POST_USER_ERROR = 'fulcrum/container/Admin/User/UserSelection/POST_USER_ERROR'

const ROW_OPTIONS = Object.freeze({
  10: 10,
  25: 25,
  50: 50
})

const ROLE_OPTIONS = Object.freeze({
  'Limited Access': 'Limited Access',
  'Full Access': 'Full Access',
  'Admin Access': 'Admin Access',
})

export {
  ROW_OPTIONS,
  ROLE_OPTIONS,
  CHANGE_PAGE_SIZE,
  CHANGE_CURRENT_PAGE,
  CHANGE_SEARCH_VALUE,
  FETCH_USERS,
  FETCH_USERS_START,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_ERROR,
  UPDATE_PAGE_SIZE,
  UPDATE_COUNT_SIZE,
  UPDATE_CURRENT_PAGE,
  UPDATE_USER_LIST,
  UPDATE_SEARCH_VALUE,
  CLEAR_USER_LIST,
  USER_SELECTION,
  POST_USER,
  POST_USER_START,
  POST_USER_SUCCESS,
  POST_USER_ERROR,
}
